import { useContext } from "react";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";
import { ApiContext } from "../../contexts/ApiContext";
import { useQuery } from "react-query";
import { ReportDocument } from "../../shared/interfaces/ReportDocument";

export function useReportDocumentById(reportDocumentId: number, callbacks?: QueryCallbacks<ReportDocument>) {
  const apiContext = useContext(ApiContext);

  return useQuery({
    queryKey: ["reportById", reportDocumentId],
    queryFn: async () => {
      if (reportDocumentId) return await apiContext.utp2ReportsAPIs.getReportDocumentById(reportDocumentId);
    },
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
  });
}
